import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { Charts } from "shared/components";
import { useMobileOrientation } from "react-device-detect";
import { releaseColumns } from "../CareerCatalogAnalysis";

interface CareerReleasesMobileProps {
  lastReleases: any;
  releasePolynomialCurveTrend: any;
}
const CareerReleasesMobile: React.FC<CareerReleasesMobileProps> = (props) => {
  const { lastReleases, releasePolynomialCurveTrend } = props;
  const { t } = useTranslation("radar");
  const { isPortrait } = useMobileOrientation();

  const chartMeasures = {
    height: isPortrait ? 150 : 250,
    width: isPortrait ? 150 : 550,
    containerHeight: isPortrait ? 150 : 250,
    containerWidth: "100%",
  };

  if (isPortrait) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center" }}
        className="latam-banner"
      >
        <span>
          {t("pages.CareerDiagnose.turnThePhoneHorizontalDisclaimer")}
        </span>
      </div>
    );
  }
  return (
    <div>
      <div style={{ justifyContent: "space-between" }}>
        <h3>{t("pages.CareerDiagnose.popularityReleasesTrend")}</h3>{" "}
      </div>
      <div style={{ color: "#000" }}>
        <Charts.ScatterChart
          scatterData={releasePolynomialCurveTrend?.data}
          lineData={releasePolynomialCurveTrend?.polynomialCurve}
          tooltip={{
            points: releasePolynomialCurveTrend?.data,
            title: t("pages.ArtistProfile.release"),
            name: t("pages.ArtistProfile.name"),
            release: t("pages.ArtistProfile.releaseDate"),
            ageInMonths: t("pages.ArtistProfile.ageInMonths"),
            popularity: t("pages.ArtistProfile.popularity"),
            type: t("pages.ArtistProfile.type"),
          }}
          horizontalLegendAlign="center"
          customLegendItems={[t("pages.ArtistProfile.releaseTrendLegend")]}
          {...chartMeasures}
        />
      </div>
      <h1 className="title">
        {t("pages.CareerDiagnose.topReleasesByPopularity")}
      </h1>
      <Table
        columns={releaseColumns(t)}
        pagination={false}
        dataSource={lastReleases?.artistReleases?.slice(0, 5)}
      />
    </div>
  );
};

export default CareerReleasesMobile;
